import React, { useEffect, useState } from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Checkbox from "@mui/material/Checkbox";
import Avatar from "@mui/material/Avatar";
import { Tooltip, Typography } from "@mui/material";
import defaultPofile from "../../assets/default-profile.jpg";
import SearchBox from "../../common/components/SearchBox";

import { getActiveCandidates } from "../../../store/psychometric/actions";
import { connect, useDispatch } from "react-redux";
import ReactPaginate from "react-paginate";

function LiveCandidateCard({
  selectedCandidate,
  setSelectedCandidate,
  getActiveCandidates,
  activeCandidates,
  totalActiveCandidates,
  set,
}) {
  // const [checked, setChecked] = useState([1]);

  // const handleToggle = (value) => () => {
  //   const currentIndex = checked.indexOf(value);
  //   const newChecked = [...checked];

  //   if (currentIndex === -1) {
  //     newChecked.push(value);
  //   } else {
  //     newChecked.splice(currentIndex, 1);
  //   }

  //   setChecked(newChecked);
  // };

  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading1, setIsLoading1] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(10);

  const onSearch = () => {
    if (!searchTerm) return false;
    const query = {
      searchTerm: searchTerm,
      page: currentPage,
      size: itemPerPage,
    };
    getActiveCandidates(query, set, setIsLoading);
  };

  useEffect(() => {
    const query = {
      searchTerm: searchTerm,
      page: currentPage,
      size: itemPerPage,
    };
    getActiveCandidates(query, set, setIsLoading);
  }, []);

  useEffect(() => {
    console.log("currentPage", currentPage);
  }, [currentPage]);

  // useEffect(() => {
  //   const timer = setInterval(() => {
  //     console.log(getCurrentPage());

  //     const query = {
  //       searchTerm: searchTerm,
  //       page: getCurrentPage(),
  //       size: itemPerPage,
  //     };
  //     getActiveCandidates(query, set, setIsLoading, true);
  //   }, 10000);

  //   return () => clearInterval(timer);
  // }, []);

  // const getCurrentPage = () => currentPage;

  const handlePageClick = ({ selected }) => {
    const currentPage = selected + 1;

    setCurrentPage(currentPage);

    const query = {
      searchTerm: searchTerm,
      page: currentPage,
      size: itemPerPage,
    };

    getActiveCandidates(query, set, setIsLoading);
  };

  return (
    <>
      <div>
        <SearchBox
          onKeyPress={onSearch}
          onSearch={(search) => {
            setSearchTerm(search);

            if (!search) {
              const currentPage = 1;
              setCurrentPage(currentPage);
              const query = {
                searchTerm: "",
                page: currentPage,
                size: itemPerPage,
              };
              getActiveCandidates(query, set, setIsLoading1);
            }
          }}
          placeholder="Search…"
        />
      </div>

      <List dense>
        {activeCandidates.map((candidate) => (
          <ActiveCandidateCardItem
            key={candidate.id}
            candidate={candidate}
            selectedCandidate={selectedCandidate}
            setSelectedCandidate={setSelectedCandidate}
          />
        ))}
      </List>
      <div
        className="d-flex justify-content-center  align-items-center"
        style={{ overflow: "hidden" }}
      >
        <div className="mt-3">
          <ReactPaginate
            breakLabel="..."
            nextLabel={
              <>
                {/* <span className="pr-1 d-none d-md-inline">Next</span> */}
                <i className="fas fa-angle-double-right"></i>
              </>
            }
            previousLabel={
              <>
                <i className="fas fa-angle-double-left"></i>
                {/* <span className="pl-1  d-none d-md-inline">Previous</span> */}
              </>
            }
            pageRangeDisplayed={3}
            marginPagesDisplayed={1}
            onPageChange={handlePageClick}
            pageCount={Math.ceil(totalActiveCandidates / itemPerPage)}
            renderOnZeroPageCount={null}
            containerClassName="pagination"
            pageLinkClassName="btn btn-outline-info btn-sm mr-1 ml-1"
            previousLinkClassName="btn btn-outline-info btn-sm mr-1 ml-1"
            nextLinkClassName="btn btn-outline-info btn-sm ml-1"
            activeLinkClassName="active"
          />
        </div>
      </div>
    </>
  );
}

const mapStateToProps = ({ user, loading, activeCandidates }) => {
  return {
    user,
    loading,
    activeCandidates,
  };
};
export default connect(mapStateToProps, {
  getActiveCandidates,
})(LiveCandidateCard);

const ActiveCandidateCardItem = ({
  candidate,
  selectedCandidate,
  setSelectedCandidate,
}) => {
  useEffect(() => {
    if (!!selectedCandidate && candidate.id === selectedCandidate?.id)
      setSelectedCandidate(candidate);

    return () =>
      candidate.id === selectedCandidate?.id && setSelectedCandidate(null);
  }, [candidate]);

  return (
    <>
      <ListItem
        onClick={() => setSelectedCandidate(candidate)}
        className={`${
          candidate.id === selectedCandidate?.id ? "active border" : ""
        } `}
        divider
        secondaryAction={
          <Tooltip
            title={`${candidate.isSessionLocked ? "Locked" : "Active"} `}
          >
            <span
              className={`material-icons text-${
                candidate.isSessionLocked ? "danger" : "success"
              } cursor-pointer`}
            >
              fiber_manual_record
            </span>
          </Tooltip>
        }
        disablePadding
      >
        <ListItemButton>
          <ListItemAvatar>
            <Avatar
              alt={`${candidate.lastName} ${candidate.firstName}`}
              src={defaultPofile}
            />
          </ListItemAvatar>
          <ListItemText
            id={candidate.id}
            primary={
              <span className="font-weight-bold">
                {candidate.no}: {candidate.lastName} {candidate.firstName}
              </span>
            }
            secondary={
              <React.Fragment>
                <small className="d-block">{candidate.positionName}</small>
                <small className="d-block">{candidate.entityName}</small>
                <small className="d-block text-primary  ">
                  {candidate.sectorName}
                </small>
                {/* <Typography component="p"></Typography> */}
              </React.Fragment>
            }
          />
        </ListItemButton>
      </ListItem>
    </>
  );
};
